import type { IconProps } from './types';

export const Lock = ({ size, ...props }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.16667 7.05438V4.38772C4.16584 3.56108 4.47219 2.76363 5.02625 2.15016C5.58031 1.53669 6.34255 1.15098 7.165 1.06791C7.98745 0.984833 8.81143 1.21032 9.47698 1.70059C10.1425 2.19086 10.6022 2.91095 10.7667 3.72105M2.83333 7.05438H12.1667C12.903 7.05438 13.5 7.65134 13.5 8.38772V13.0544C13.5 13.7908 12.903 14.3877 12.1667 14.3877H2.83333C2.09695 14.3877 1.5 13.7908 1.5 13.0544V8.38772C1.5 7.65134 2.09695 7.05438 2.83333 7.05438Z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
